<template>
  <div class="OuterOrderOffertDetail-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
           报价详细
          </div>
          <div class="card-content" v-loading="loading">
            <div>
              <span style="color:#99a9bf" v-if="orderinfo.bid!==3">生产单号：</span>
              <span style="color:#99a9bf" v-if="orderinfo.bid===3">订单号：</span>
              <span style="color:#409EFF;font-weight: 500">{{orderinfo.bid===3?orderinfo.ordernum:orderinfo.produnum}}</span>
<!--              <span style="color:#99a9bf;margin-left: 20px">订单号：</span>-->
<!--              <span>{{orderinfo.ordernum}}</span>-->
<!--              <span style="color:#99a9bf;margin-left: 20px">详细地址：</span>-->
<!--              <span>{{orderinfo.address}}</span>-->
              <span style="color:#99a9bf;margin-left: 20px">色板来源：</span>
              <span>{{orderinfo.source}}</span>
<!--              <span v-if="orderinfo.source===0">厂部标准色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===1">客户提供色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===2">厂部定制色板</span>-->
<!--              <span style="color:#99a9bf;margin-left: 20px">设计师：</span>-->
<!--              <span>{{orderinfo.designer}}</span>-->
            </div>
            <div style="margin-top: 20px">
              <span style="color:#99a9bf">接单日期：</span>
              <span>{{orderinfo.receive_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单日期：</span>
              <span>{{orderinfo.split_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">排产日期：</span>
              <span>{{orderinfo.schedule_time}}</span>
              <span style="color:#99a9bf;margin-left: 20px">预计交期：</span>
              <span>{{orderinfo.planned}}</span>
            </div>
<!--            <div style="margin-top: 20px;">-->
<!--              <span style="color:#99a9bf">报价备注：</span>-->
<!--              <span v-if="orderinfo.remark!==''&&orderinfo.remark!==null">{{orderinfo.remark}}</span>-->
<!--              <span v-else>暂无备注</span>-->
<!--            </div>-->
            <div style="margin-top: 20px;" v-if="orderinfo.other>0">
              <span style="color:#99a9bf">其他费用：</span>
              <span style="font-weight: 500;color:#409EFF;margin-right: 4px">{{otherTotalAmount}}</span>元
              <table class="tcf-detail-table" style="margin-top: 20px">
                <tr style="color: #909399;background-color: #f5f7fa;font-weight: 500;">
                  <td style="width: 50px;text-align: center;">#</td>
                  <td style="width: 80px;text-align: center">金额</td>
                  <td style="text-align: left">其他费用说明</td>
                </tr>
                <tr v-for="(d,index) in orderinfo.otherlst" v-if="d.type!==2||user.group_nature!==1">
                  <td style="text-align: center">{{ index+1 }}</td>
                  <td style="font-weight: 500;color:#409EFF;text-align: center">{{ d.proamount }}</td>
                  <td>{{d.type===2&&user.group_nature===1?'其他费用':d.name}}</td>
                </tr>
              </table>
            </div>
            <div style="padding-top: 30px;border-top: 1px solid #f5f7fa;margin-top:30px;">
              <el-form :inline="true" size="small" :model="searchForm">
                <el-form-item label="区域">
                  <el-select v-model="searchForm.area" style="width: 150px" filterable clearable>
                    <el-option
                      v-for="item in searchForm.areaList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分类">
                  <el-select v-model="searchForm.type" style="width: 100px" filterable clearable>
                    <el-option
                      v-for="item in searchForm.typeList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="搜索关键字">
                  <el-input @keyup.enter.native="searchMaterial" v-model="searchForm.search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchMaterial" icon="el-icon-search">搜索</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" :loading="exportLoading" plain @click="exportMaterial" icon="el-icon-printer">导出Excel</el-button>
                </el-form-item>
                <el-form-item style="float: right;">
                  <span style="margin-right:20px;">数量合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalCount }}</span></span>
                  <span>金额合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalMoney }}</span></span>
                </el-form-item>
              </el-form>
              <div v-loading="materialloading" style="height: 490px;width: 100%">
                <pl-table
                  :key="tableKey"
                  height="490px"
                  :datas="materialTableData"
                  :data="materialTableData"
                  use-virtual
                  :pagination-show="false"
                  size="small"
                  :row-height="45">
                  <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed />
                  <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip />
                  <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip />
                  <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip />
                  <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip />
                  <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip />
                  <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip />
                  <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip />
                  <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip />
                  <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip />
                  <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip />
                  <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip />
                  <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip />
                  <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
<!--                  <pl-table-column fixed="right" prop="price" label="单价" width="100" show-overflow-tooltip />-->
                  <pl-table-column fixed="right" prop="proamount" label="生产金额" width="100" show-overflow-tooltip />
                </pl-table>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpOrderPartsDetail, getErpOrderMaterialDetail, getErpOrderMaterialDetailExport } from '@/api/erp'

export default {
  name: 'OuterOrderOffertDetail',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      orderid: '',
      loading: false,
      tableKey: '',
      materialloading: false,
      materialTableData: [],
      orderinfo: [],
      otherTotalAmount: 0,
      searchForm: {
        area: '',
        type: '',
        search: '',
        areaList: [],
        typeList: []
      },
      totalCount: 0,
      totalMoney: 0,
      allMaterialData: [],
      exportLoading: false
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      getErpOrderPartsDetail({ orderid: this.orderid }).then(response => {
        this.orderinfo = response.data
        let _otherTotalAmount = 0
        for (const d of this.orderinfo.otherlst) {
          if (d.type !== 2 || this.user.group_nature !== 1) {
            _otherTotalAmount += parseFloat(d.proamount)
          }
        }
        this.otherTotalAmount = _otherTotalAmount.toFixed(2)
        let pageTitle = ''
        if (this.orderinfo.bid === 3) {
          pageTitle = `报价详细 ${this.orderinfo.ordernum}`
        } else {
          pageTitle = `报价详细 ${this.orderinfo.produnum}`
        }
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.getMaterialDetail()
      }).catch(() => {
        this.loading = false
      })
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialloading = true
      this.searchForm.area = ''
      this.searchForm.type = ''
      this.searchForm.search = ''
      this.totalMoney = 0
      this.totalCount = 0
      getErpOrderMaterialDetail({ orderid: this.orderid,groupid: this.user.dGroupid }).then(response => {
        this.tableKey = new Date().getTime()
        this.materialTableData = response.data
        this.allMaterialData = response.data
        const areaArray = []
        const typeArray = []
        let money = 0
        let count = 0
        for (const item of this.materialTableData) {
          let haveArea = false
          for (let i = 0; i < areaArray.length; i++) {
            if (areaArray[i] === item.area) {
              haveArea = true
              break
            }
          }
          if (!haveArea) {
            areaArray.push(item.area)
          }
          let haveType = false
          for (let i = 0; i < typeArray.length; i++) {
            if (typeArray[i] === item.type) {
              haveType = true
              break
            }
          }
          if (!haveType) {
            typeArray.push(item.type)
          }
          money += item.proamount
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
          item.price = (item.price * (item.prodis / 10)).toFixed(2)
        }
        this.totalMoney = money.toFixed(2)
        this.totalCount = parseInt(count)
        this.searchForm.areaList = areaArray
        this.searchForm.typeList = typeArray
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    searchMaterial() {
      let newMaterial = []
      let money = 0
      let count = 0
      for (let item of this.allMaterialData) {
        let flage = true
        if (this.searchForm.area !== '') {
          if (item.area !== this.searchForm.area) {
            flage = false
          }
        }
        if (this.searchForm.type !== '') {
          if (item.type !== this.searchForm.type) {
            flage = false
          }
        }
        if (this.searchForm.search !== '') {
          if (item.name.indexOf(this.searchForm.search) < 0 && item.xuhao.indexOf(this.searchForm.search) < 0 && item.material.indexOf(this.searchForm.search) < 0 && item.color.indexOf(this.searchForm.search) < 0) {
            flage = false
          }
        }
        if (flage) {
          money += item.proamount
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
          newMaterial.push(item)
        }
      }
      this.totalMoney = money.toFixed(2)
      this.totalCount = parseInt(count)
      this.materialTableData = newMaterial
    },
    exportMaterial() {
      if (!this.exportLoading) {
        this.exportLoading = true
        getErpOrderMaterialDetailExport({ orderid: this.orderid,groupid: this.user.dGroupid }).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
  }
}
</script>
